import { useContext, useRef } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import { BookACallPageView } from '@Views/eligibility/loan-preferences/book-call-page-view/BookACallPageView';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

export const LoanPreferencesBookCallPage = () => {
    const { loading } = useContext(ApplicationContext);

    const saveRef = useRef(null);

    return (
        <EligibilityLayout loading={loading} ref={saveRef}>
            <BookACallPageView />
        </EligibilityLayout>
    );
};
